import { Box, Collapse } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import get from 'lodash/get';
import styled from 'styled-components';
import { TableNoVerticalLinesAndNoFirstAndLastBorder } from '../../components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import Table from 'components/base/Table';
import {
  getTableConfig,
  getSensorsTableData
} from './multiple-connectivity-issues-bar.service';
import MultipleConnectivityTitle from './MultipleConnectivityTitle';

const TRANSITION_MS = 200;

const TableBox = styled(TableNoVerticalLinesAndNoFirstAndLastBorder)`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  border-top: 0;
  padding-top: 1.5rem;
  border: 1px solid ${getColor('pastelPink')};
  background-color: ${getColor('white')};
  border-radius: 0rem 0rem 0.45rem 0.45rem;
`;

const MultipleConnectivityIssuesBar = ({
  failingSensorsAuthorizations,
  rateLimitSensorsAuthorizations
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  // NOTE: removing this causes this component to perform slowly, leaving this for now until
  // we can do a more through refactor
  // eslint-disable-next-line
  const [_isRoundBorder, setIsRoundBorder] = useState(true);
  const [currentBasePath, setCurrentBasePath] = useState(null);
  const location = useLocation();

  const issueSensors = useMemo(
    () => [...failingSensorsAuthorizations, ...rateLimitSensorsAuthorizations],
    [failingSensorsAuthorizations, rateLimitSensorsAuthorizations]
  );

  const toggle = () => {
    const expanded = isExpanded;
    setIsExpanded(!expanded);

    if (!expanded) {
      setIsRoundBorder(false);
    } else {
      setTimeout(() => setIsRoundBorder(true), TRANSITION_MS);
    }
  };
  // close the accordion whenever the base path changes
  useEffect(() => {
    const splitPath = location.pathname.split(/[/?]/g);
    const newBasePath = get(splitPath, ['1'], '');
    if (newBasePath !== currentBasePath && isExpanded) {
      setCurrentBasePath(newBasePath);
      toggle();
    }
  }, [location.pathname]);

  const issueSensorsTableData = useMemo(
    () =>
      getSensorsTableData({
        failingSensorsAuthorizations,
        rateLimitSensorsAuthorizations
      }),
    [failingSensorsAuthorizations, rateLimitSensorsAuthorizations]
  );

  return (
    <Box
      margin={1}
      marginTop={2}
      data-cy='multiple-connectivitiy-issues-wrapper'
    >
      <MultipleConnectivityTitle
        failingSensorsAuthorizations={failingSensorsAuthorizations}
        rateLimitSensorsAuthorizations={rateLimitSensorsAuthorizations}
        toggle={toggle}
        isExpanded={isExpanded}
      />

      {issueSensors?.length > 1 && (
        <Collapse
          data-testid='collapsible-failing-sensors'
          in={isExpanded}
          timeout={TRANSITION_MS}
        >
          <TableBox>
            {/* @ts-expect-error */}
            <Table columns={getTableConfig()} data={issueSensorsTableData} />
          </TableBox>
        </Collapse>
      )}
    </Box>
  );
};

export default MultipleConnectivityIssuesBar;
